import { useQuery } from 'react-query'
import { StatsService } from './services'

export const useStats = (enabled: boolean = false) => {
  return useQuery('stats', StatsService.getStats, {
    enabled: enabled,
  })
}
